<template>
    <div>
        <el-button type="text" @click.stop="setPlateImage()">
            {{ setImageName(plate) }}
        </el-button>

        <el-dialog :visible.sync="dialogVisible" width="60%">
            <span slot="title">
                <span>{{ $t('table.column.plateNo') }}</span>
            </span>
            <v-progress-circular
                v-if="showLoadingImage"
                indeterminate
                color="primary"
            ></v-progress-circular>
            <img style="width: 100%; height: auto" :src="plateImage" />
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'plate',
    props: {
        plate: {},
        plateNo: '',
    },
    data() {
        return {
            dialogVisible: false,
            plateImage: '',
            showLoadingImage: false,
        }
    },
    watch: {
        dialogVisible: function (dialogVisible) {
            if (dialogVisible) {
                document.getElementById('app').style.overflow = 'hidden'
            } else {
                document.getElementById('app').style.overflow = 'auto'
            }
        },
    },
    methods: {
        setPlateImage() {
            this.dialogVisible = true
            this.showLoadingImage = true
            this.plateImage = this.plate.ImageUri
            this.showLoadingImage = false
        },

        setImageName(row) {
            return `${this.plateNo} (${
                row.LaneNo && row.LaneNo !== 0
                    ? `Lane${row.LaneNo}`
                    : 'TailGate'
            })`
        },
    },
}
</script>
